import { ApexApiError, HTTPMethod } from "types";

const defaultHeaders = new Headers({
  "Content-Type": "application/json",
});

function get(url: string, headers = defaultHeaders, skipJSON = false) {
  return dispatch(url, HTTPMethod.GET, undefined, headers, skipJSON);
}

function put(url: string, payload: BodyInit, skipJSON = false) {
  return dispatch(url, HTTPMethod.PUT, payload, defaultHeaders, skipJSON);
}

function post(
  url: string,
  payload: BodyInit,
  headers = defaultHeaders,
  skipJSON = false
) {
  return dispatch(url, HTTPMethod.POST, payload, headers, skipJSON);
}

function destroy(url: string, payload?: BodyInit, skipJSON = false) {
  return dispatch(url, HTTPMethod.DELETE, payload, undefined, skipJSON);
}

async function dispatch(
  url: string,
  method: HTTPMethod,
  payload?: BodyInit,
  headers = defaultHeaders,
  skipJSON = false
) {
  const config: RequestInit = {
    method,
    headers,
    mode: "cors",
    credentials: "include",
  };
  if (payload) {
    config.body = payload;
  }
  const response = await fetch(url, config);
  if (!response.ok) {
    const error: ApexApiError = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  let data;

  // Some endpoints don't return json
  if (skipJSON) {
    data = response;
  } else {
    data = response.json();
  }
  if (headers.get("Content-Type") === "text/plain") {
    data = response.text();
  }
  return data;
}

export { get, put, post, destroy };
